/**
 * PDP worn-gallery horizontal scroll — ported from pdp_demo_v1.html's assets/global/
 * pdp-immersive.js `scrollWorn()` (same `scrollBy` pattern as
 * assets/community-style-gallery.js, different CSS — see sections/pdp-worn-gallery.liquid's
 * doc comment).
 *
 * Delegated on `document` rather than bound to specific button nodes on load, matching
 * snippets/pdp-accordion.liquid's own delegation pattern — this section's `.worn-track` can
 * be morphed by assets/pdp-variant-morph.js on variant change, and delegation means the
 * click handler keeps working without needing to re-bind listeners after that morph.
 */
document.addEventListener('click', (event) => {
  const prevButton = event.target.closest('[data-worn-prev]');
  const nextButton = event.target.closest('[data-worn-next]');
  if (!prevButton && !nextButton) return;

  const track = event.target.closest('.worn-section')?.querySelector('[data-worn-track]');
  if (!track) return;

  track.scrollBy({ left: (prevButton ? -1 : 1) * track.clientWidth * 0.82, behavior: 'smooth' });
});
